import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  loadingToggleAction,
  loginAction,
  customTokenLoginAction,
} from "../../store/actions/AuthActions";

//
import logo from "../../images/BB_Logo_White.svg";
import logotext from "../../images/logo-full.png";
import login from "../../images/bg-login2.png";
import loginbg from "../../images/bg-login.jpg";
import firebase from "../firebase"; // Adjust the path as necessary
import {
  getAuth,
  signInWithEmailAndPassword,
  signInWithCustomToken,
  sendPasswordResetEmail,
} from "firebase/auth";
// WEB3
import { useAccount } from "wagmi";

import { useContext } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useLocation } from "react-router-dom";

function Login(props) {
  const location = useLocation();
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  // WEB3
  const { address, isConnecting, isDisconnected } = useAccount();
  const [loading, setLoading] = useState(false);
  const [SuccessPW, setSuccessPW] = useState(false);
  const [pwdisabled, setpwdisabled] = useState(false);

  const [twoFactorToken, setTwoFactorToken] = useState("");
  const [is2FARequired, setIs2FARequired] = useState(false);
  const [localUser, setLocalUser] = useState(null);

  const [twofactorerror, settwofactorerror] = useState("");
  const [twofactorsuccess, settwofactorsuccess] = useState(false);

  // UseEffect with address
  useEffect(() => {
    console.log("Disconnected Wallet");
  }, [isDisconnected]);

  const handleWeb3Login = async (isTwoFactorSuccess) => {
    const ethAddress = address;
    setLoading(true);
    try {
      const response = await axios.post(
        "https://api.bridge-bit.com/api/generateCustomToken",
        {
          ethAddress,
        }
      );

      const { customToken } = response.data;
      console.log("response:", response);
      console.log("response.data:", response.data);
      // Authenticate with Firebase using customToken

      const auth = getAuth();
      // ...
      signInWithCustomToken(auth, customToken)
        .then((userCredential) => {
          console.log("User is signed in with custom token");
          // User is signed in with custom token
          processFirebaseUser(userCredential.user);
        })
        .catch((error) => {
          console.error("Error during Web3 Firebase login:", error);
          setLoading(false);
          // Handle login errors here
        });

      const processFirebaseUser = (firebaseUser) => {
        const firebaseUid = firebaseUser.uid;
        console.log("firebaseUid:", firebaseUid);
        fetchUserDataAndNavigate(firebaseUid);
      };

      const fetchUserDataAndNavigate = (firebaseUid) => {
        fetch(`https://api.bridge-bit.com/api/user/${firebaseUid}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error("User not found.");
            }
            return response.json();
          })
          .then((userData) => {
            console.log("User data:", userData);
            setLocalUser(userData);
            console.log("twofactorsuccess:", isTwoFactorSuccess);
            if (userData.is2faEnabled === 1 && !isTwoFactorSuccess) {
              setLoading(false);
              setIs2FARequired(true);
            } else {
              // if (userData.verified === "false") {
              //   throw new Error("E-mail not verified.");
              // }
              dispatch({ type: "SET_USER", payload: userData });
              localStorage.setItem("user", JSON.stringify(userData));

              console.log("User logged in:", userData);
              // navigate("/dashboard");

              dispatch(loadingToggleAction(true));
              // dispatch(loginAction(email, password, navigate));

              dispatch(customTokenLoginAction(customToken, navigate));
            }
          })
          .catch((error) => {
            console.error("Error fetching user data:", error);
            setLoading(false);
            setErrors({ ...errors, firebase: error.message });
            dispatch(loadingToggleAction(false));
          });
      };
    } catch (error) {
      console.error("Web3 Login Error:", error);
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  var d = new Date();
  function onLogin(e) {
    e.preventDefault();
    setLoading(true);

    // If address is available, handle Web3 login
    if (address) {
      handleWeb3Login(false);
      return;
    }

    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    dispatch(loadingToggleAction(true));

    // Firebase user login
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Login successful
        console.log("Firebase user:", userCredential.user);
        const firebaseUid = userCredential.user.uid;

        fetch(`https://api.bridge-bit.com/api/user/${firebaseUid}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error("User not found.");
            }
            return response.json();
          })
          .then((userData) => {
            setLocalUser(userData);
            if (userData.is2faEnabled === 1) {
              setLoading(false);
              setIs2FARequired(true);
            } else {
              dispatch({ type: "SET_USER", payload: userData });
              console.log("set localStorage user", userData);
              localStorage.setItem("user", JSON.stringify(userData));

              console.log("User logged in:", userData);
              if (userData.isKycAccepted === "true") {
                navigate("/dashboard");
              } else {
                navigate("/kyc");
              }

              dispatch(loadingToggleAction(true));
              dispatch(loginAction(email, password, navigate));
            }
          })
          .catch((error) => {
            console.error("Error fetching user data:", error);
            setLoading(false);
            setErrors({ ...errors, firebase: error.message });
            dispatch(loadingToggleAction(false));
          });
      })
      .catch((error) => {
        console.error("Error logging in user:", error);
        console.log("error.message", error.message);
        if (error.message === "Firebase: Error (auth/invalid-credential).") {
          setErrors({ ...errors, firebase: "Invalid Email or Password" });
        } else {
          setErrors({ ...errors, firebase: error.message });
        }
        setLoading(false);
        dispatch(loadingToggleAction(false));
      });

    // ...
  }

  const actionCodeSettings = {
    // Your custom page URL to handle the action
    url: "http://bridge-bit.com/password-reset",
    // This must be true.
    handleCodeInApp: true,
  };

  const handlePasswordReset = (email) => {
    console.log("email", email);
    setpwdisabled(true);
    if (email === "") {
      console.log("No Mails");
      setErrors({ ...errors, email: "Email is Required" });
      return;
    } else {
      const auth = getAuth();
      sendPasswordResetEmail(auth, email, actionCodeSettings)
        .then(() => {
          console.log("Password reset email sent.");
          setSuccessPW(true);
        })
        .catch((error) => {
          console.error("Error sending password reset email:", error);
          // Handle errors.
        });
    }
  };

  const handle2FAVerification = async () => {
    try {
      // Verify the 2FA token
      let userid = localUser.id;
      const { status } = await axios.post(
        "https://api.bridge-bit.com/api/verify2fa",
        { userid, twoFactorToken }
      );
      console.log("status", status);
      if (status === 200) {
        setLoading(true);
        settwofactorsuccess(true);

        // If address is available, handle Web3 login
        if (address) {
          handleWeb3Login(true);
          return;
        }

        dispatch({ type: "SET_USER", payload: localUser });
        console.log("set localStorage user", localUser);
        localStorage.setItem("user", JSON.stringify(localUser));

        console.log("User logged in:", localUser);
        if (localUser.isKycAccepted === "true") {
          navigate("/dashboard");
        } else {
          navigate("/kyc");
        }

        dispatch(loadingToggleAction(true));
        dispatch(loginAction(email, password, navigate));
      } else if (status === 400) {
        settwofactorerror("Invalid 2FA token.");
        console.log("Invalid 2FA token.");
      }
    } catch (error) {
      settwofactorerror("Invalid 2FA token.");
      console.log("Invalid 2FA token.");
    }
  };

  return (
    <div
      className="authincation h-100 p-meddle"
      style={{
        background: "white",
        WebkitFontSmoothing: "antialiased",
        fontFamily: "var(--wui-font-family)",
        fontStyle: "normal",
        textRendering: "optimizespeed",
        fontWeight: "bold",
        fontSize: "1rem",
        padding: "0.5rem 0.75rem",
      }}
    >
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6">
            <div
              className="authincation-content"
              style={{ background: "black", borderRadius: "20px" }}
            >
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form" style={{ padding: "20px 20px" }}>
                    <div className="mb-4 text-center">
                      <img
                        src={logo}
                        alt=""
                        className="me-2"
                        style={{ width: "150px" }}
                      />
                    </div>
                    {message && <div className="alert-message">{message}</div>}
                    {errors.firebase && (
                      <h4
                        className="text-danger"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {errors.firebase}
                      </h4>
                    )}
                    {props.errorMessage && (
                      <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                        {props.errorMessage}
                      </div>
                    )}
                    {props.successMessage && (
                      <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                        {props.successMessage}
                      </div>
                    )}
                    <form onSubmit={onLogin}>
                      <div className="form-group">
                        <label className="mb-2 ">
                          <strong className="text-white">Email</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control text-black"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          style={{ opacity: address ? 0.6 : 1 }}
                          disabled={address}
                        />
                        {errors.email && (
                          <div className="text-danger fs-14 mt-1">
                            {errors.email}
                          </div>
                        )}
                      </div>
                      <div
                        className="form-group"
                        style={pwdisabled ? { display: "none" } : {}}
                      >
                        <label className="mb-2 ">
                          <strong className="text-white">Password</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control text-black"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={{ opacity: address || pwdisabled ? 0.6 : 1 }}
                          disabled={address || pwdisabled}
                        />
                        {errors.password && (
                          <div className="text-danger fs-12">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      {is2FARequired && (
                        <div className="form-group">
                          <label className="mb-2 ">
                            <strong className="text-white">2FA</strong>
                          </label>
                          <input
                            type="text"
                            className="form-control text-black"
                            placeholder="Enter 2FA token"
                            value={twoFactorToken}
                            onChange={(e) => setTwoFactorToken(e.target.value)}
                          />
                        </div>
                      )}

                      {twofactorerror !== "" && (
                        <div
                          className="alert alert-danger"
                          style={{
                            textAlign: "center",
                            marginTop: "1rem",
                            padding: "0.5rem 1rem",
                          }}
                        >
                          {twofactorerror}
                        </div>
                      )}

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          display: pwdisabled ? "none" : "flex",
                        }}
                      >
                        {!is2FARequired ? (
                          <button
                            type="submit"
                            className="btn bg-white text-black btn-block"
                            style={{
                              borderRadius: "45px",
                              maxWidth: "150px",
                              WebkitFontSmoothing: "antialiased",
                              fontFamily: "var(--wui-font-family)",
                              fontStyle: "normal",
                              textRendering: "optimizespeed",
                              fontWeight: "bold",
                              fontSize: "1rem",
                              padding: "0.5rem 0.75rem",
                              height: "fit-content",
                            }}
                          >
                            {" "}
                            {loading && (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                              />
                            )}
                            {loading ? (
                              ""
                            ) : (
                              <>{address ? "Wallet Sign In" : "Sign In"}</>
                            )}
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="btn bg-white text-black btn-block"
                            style={{
                              borderRadius: "45px",
                              maxWidth: "150px",
                              WebkitFontSmoothing: "antialiased",
                              fontFamily: "var(--wui-font-family)",
                              fontStyle: "normal",
                              textRendering: "optimizespeed",
                              fontWeight: "bold",
                              fontSize: "1rem",
                              padding: "0.5rem 0.75rem",
                              height: "fit-content",
                            }}
                            onClick={handle2FAVerification}
                          >
                            {" "}
                            {loading && (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                              />
                            )}
                            {loading ? (
                              ""
                            ) : (
                              <>{address ? "Wallet Sign In" : "Sign In"}</>
                            )}
                          </button>
                        )}

                        {/* <w3m-button />{" "} */}
                      </div>
                    </form>
                    {/* <button
                        onClick={() => open()}
                        className="btn bg-white text-primary btn-block mt-2"
                      >
                        Connect Wallet
                      </button> */}

                    <div
                      className="col-xl-12 mt-2 text-center"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        display: pwdisabled ? "none" : "flex",
                      }}
                    >
                      <w3m-button />
                    </div>
                    {/* Add this inside your form, near the Sign In button */}
                    {SuccessPW && (
                      <div
                        className="alert alert-success"
                        style={{ textAlign: "center", marginTop: "1rem" }}
                      >
                        Password reset email sent.
                      </div>
                    )}
                    <div
                      className="forgot-password-link "
                      style={{ textAlign: "center", marginTop: "1rem" }}
                    >
                      <a
                        href="#"
                        className="text-white"
                        onClick={() => handlePasswordReset(email)}
                      >
                        Forgot password?
                      </a>
                    </div>

                    {/* <button
                      onClick={() => handleWeb3Login()}
                      className="btn bg-white text-primary btn-block mt-2"
                      disabled={!address}
                    >
                      TEST WALLET LOGIN
                    </button>{" "} */}
                    {/* <button onClick={() => open({ view: "Networks" })}>
                        Open Network Modal
                      </button> */}
                    {/* <div className="new-account mt-2">
                        <p className="text-white">
                          Don't have an account?{" "}
                          <Link className="text-light" to="/page-register">
                            Sign up
                          </Link>
                        </p>
                      </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
